import { ErrorHandlerCaller as EHC, DEFAULTS_HANDLERS } from "@/utils/errors"
import { HTTP } from "@/utils/http-common"

export default {
  get: function ($, projectId = null) {
    return new Promise((resolve, reject) => {
      HTTP.get(`/projects${projectId ? "/" + projectId : ""}/steps`)
        .then(response => resolve(response.data))
        .catch(error => {
          return reject(error)
        })
    })
  },
  create: function ($, projectId, step) {
    return new Promise((resolve, reject) => {
      HTTP.post(`/projects/${projectId}/steps`, step)
        .then(response => resolve(response.data))
        .catch(error => {
          new EHC(DEFAULTS_HANDLERS).intercept(error)
          return reject(error)
        })
    })
  },
  update: function ($, id, step) {
    return new Promise((resolve, reject) => {
      HTTP.patch(`/projects/steps/${id}`, step)
        .then(response => resolve(response.data))
        .catch(error => {
          new EHC(DEFAULTS_HANDLERS).intercept(error)
          return reject(error)
        })
    })
  },
  remove: function ($, id) {
    return new Promise((resolve, reject) => {
      HTTP.delete(`/projects/steps/${id}`)
        .then(response => resolve(response.data))
        .catch(error => {
          new EHC(DEFAULTS_HANDLERS).intercept(error)
          return reject(error)
        })
    })
  }
}
